import { type IProductShippingRequest, ProductShippingResponseSchema } from '@/schemas/catalog/catalogSchemas'
import { api, apiService } from '@/services/core/ApiService'
import { useZipCodeStore } from '@/stores/useZipCodeStore'
import { normalizeZipCode } from '~/schemas/customer/address'
import type { IShippingQuote } from '~/schemas/shared/shipping'

// ===== FRETE DA PDP (POST product/calc-product-shipping) =====

/**
 * Cotações de frete de um produto para o CEP. Ação do cliente na PDP (só no navegador): o erro da API ("CEP
 * inválido", "Erro ao calcular o frete") sai no toast padrão e rejeita, para o hook marcar `isError`. No sucesso, o CEP
 * vira o preferido do visitante (`useZipCodeStore`).
 */
export const calcProductShippingService = ({
    zipcode,
    productId,
    quantity,
}: IProductShippingRequest): Promise<IShippingQuote[]> =>
    apiService(api)
        .post(
            'product/calc-product-shipping',
            { zipcode: normalizeZipCode(zipcode), productId, quantity },
            ProductShippingResponseSchema,
        )
        .onSuccess(() => useZipCodeStore.getState().setZipCode(zipcode))
        .execute()
        .then((data) => data.shipmentResponse.quotes)
